module.exports = __webpack_public_path__ + "static/senior-7-104d471ce7e05d47e11d195eeaad98d2.png";